import { LOCATION_CHANGE } from 'react-router-redux';
import qs from 'qs';

// Actions
const ADD_ROUTER_PARAMS_TAB = 'ADD_ROUTER_PARAMS_TAB';
const REMOVE_ROUTER_PARAMS_TABS = 'REMOVE_ROUTER_PARAMS_TABS';
const SET_ROUTER_PARAMS_TABS = 'SET_ROUTER_PARAMS_TABS';
const ADD_ROUTER_PARAMS_REDIRECT = 'ADD_ROUTER_PARAMS_REDIRECT';
const ADD_ROUTER_PARAMS_PAGE_SETTINGS = 'ADD_ROUTER_PARAMS_PAGE_SETTINGS';
const EXPAND_MAIN_NAVIGATION = 'EXPAND_MAIN_NAVIGATION';
const COLLAPSE_MAIN_NAVIGATION = 'COLLAPSE_MAIN_NAVIGATION';
const EXPAND_SETTINGS_NAVIGATION = 'EXPAND_SETTINGS_NAVIGATION';
const COLLAPSE_SETTINGS_NAVIGATION = 'COLLAPSE_SETTINGS_NAVIGATION';
const EXPAND_PRINT_NAVIGATION = 'EXPAND_PRINT_NAVIGATION';
const COLLAPSE_PRINT_NAVIGATION = 'COLLAPSE_PRINT_NAVIGATION';
const ADD_ROUTER_PARAMS_SETTINGS_SUBMENU = 'ADD_ROUTER_PARAMS_SETTINGS_SUBMENU';
const REMOVE_ROUTER_PARAMS_SETTINGS_SUBMENU = 'REMOVE_ROUTER_PARAMS_SETTINGS_SUBMENU';
const SET_ROUTER_PARAMS_SIGN_UP_SUCCESS = 'SET_ROUTER_PARAMS_SIGN_UP_SUCCESS';
const REMOVE_ROUTER_PARAMS_SIGN_UP_SUCCESS = 'REMOVE_ROUTER_PARAMS_SIGN_UP_SUCCESS';
const EXPAND_NOTIFICATIONS_DASHBOARD = 'EXPAND_NOTIFICATIONS_DASHBOARD';
const COLLAPSE_NOTIFICATIONS_DASHBOARD = 'COLLAPSE_NOTIFICATIONS_DASHBOARD';

const initialState = {
  redirect: {
    '/workflow': '/workflow/intake',
  },
  loginRedirect: null,
  tabs: {
    patient: [],
  },
  record: [],
  pageSettings: {
    '/charts': {
      limit: 10,
      offset: 0,
      sortBy: 'First Name',
      sort: 'asc',
    },
  },
  mainNavigationExpanded: undefined,
  settingsNavigationExpanded: undefined,
  printNavigationExpanded: undefined,
  settingsSubmenu: [],
  signUpSuccess: false,
  notificationsDashboardExpanded: undefined,
};

// Reducer
export default function routerParamsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ADD_ROUTER_PARAMS_REDIRECT:
      return {
        ...state,
        redirect: {
          ...state.redirect,
          ...payload,
        },
      };
    case ADD_ROUTER_PARAMS_TAB: {
      let newPatientTabs = null;
      if (state.tabs.patient && payload.patient) {
        let isPresent = false;
        newPatientTabs = state.tabs.patient.map((item) => {
          if (item.ID !== payload.patient.ID) {
            return item;
          }
          isPresent = true;
          return {
            ...item,
            ...payload.patient,
          };
        });
        if (!isPresent) {
          newPatientTabs.push(payload.patient);
        }
      }
      return {
        ...state,
        tabs: {
          ...state.tabs,
          ...newPatientTabs ? { patient: newPatientTabs } : {},
        },
      };
    }
    case REMOVE_ROUTER_PARAMS_TABS: {
      let newPatientTabs = [
        ...state.tabs.patient,
      ];
      if (state.tabs.patient && payload.patient) {
        newPatientTabs = newPatientTabs.filter(item => payload.patient.indexOf(item.ID) === -1);
      }
      return {
        ...state,
        tabs: {
          ...state.tabs,
          ...newPatientTabs ? { patient: newPatientTabs } : {},
        },
      };
    }
    case SET_ROUTER_PARAMS_TABS: {
      return {
        ...state,
        tabs: {
          ...state.tabs,
          ...payload,
        },
      };
    }
    case ADD_ROUTER_PARAMS_PAGE_SETTINGS:
      return {
        ...state,
        pageSettings: Object.keys(payload).reduce((accumulator, currentValue) => ({
          ...accumulator,
          [currentValue]: {
            ...accumulator[currentValue],
            ...payload[currentValue],
          },
        }), Object.assign({}, state.pageSettings)),
      };
    case LOCATION_CHANGE: {
      const params = qs.parse(payload.search, { ignoreQueryPrefix: true });
      if (!state.record
        || state.record.length === 0
        || state.record[state.record.length - 1].pathname !== payload.pathname) {
        return {
          ...state,
          record: [
            ...state.record || [],
            payload,
          ],
          ...!params.login && ['/account/login', '/account/reset-password', '/reload_password_check', '/new_user_verify_check'].indexOf(payload.pathname) === -1 ? {
            loginRedirect: payload.pathname,
          } : {},
        };
      }
      return {
        ...state,
        ...!params.login && ['/account/login', '/account/reset-password', '/reload_password_check', '/new_user_verify_check'].indexOf(payload.pathname) === -1 ? {
            loginRedirect: payload.pathname,
          } : {},
      };
    }
    case EXPAND_MAIN_NAVIGATION: {
      return {
        ...state,
        mainNavigationExpanded: true,
      };
    }
    case COLLAPSE_MAIN_NAVIGATION: {
      return {
        ...state,
        mainNavigationExpanded: false,
      };
    }
    case EXPAND_SETTINGS_NAVIGATION: {
      console.log('expand settings navigation');
      return {
        ...state,
        settingsNavigationExpanded: true,
      };
    }
    case COLLAPSE_SETTINGS_NAVIGATION: {
      return {
        ...state,
        settingsNavigationExpanded: false,
      };
    }
    case EXPAND_PRINT_NAVIGATION: {
      return {
        ...state,
        printNavigationExpanded: true,
      };
    }
    case COLLAPSE_PRINT_NAVIGATION: {
      return {
        ...state,
        printNavigationExpanded: false,
      };
    }
    case ADD_ROUTER_PARAMS_SETTINGS_SUBMENU: {
      return {
        ...state,
        settingsSubmenu: [
          ...state.settingsSubmenu,
          ...payload,
        ],
      };
    }
    case REMOVE_ROUTER_PARAMS_SETTINGS_SUBMENU: {
      return {
        ...state,
        settingsSubmenu: [
          ...state.settingsSubmenu,
        ].filter(item => payload.indexOf(item) === -1),
      };
    }
    case SET_ROUTER_PARAMS_SIGN_UP_SUCCESS: {
      return {
        ...state,
        signUpSuccess: true,
      };
    }
    case REMOVE_ROUTER_PARAMS_SIGN_UP_SUCCESS: {
      return {
        ...state,
        signUpSuccess: false,
      };
    }
    case EXPAND_NOTIFICATIONS_DASHBOARD: {
      return {
        ...state,
        notificationsDashboardExpanded: true,
      };
    }
    case COLLAPSE_NOTIFICATIONS_DASHBOARD: {
      return {
        ...state,
        notificationsDashboardExpanded: false,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function addRouterParamsRedirect(payload) {
  return { type: ADD_ROUTER_PARAMS_REDIRECT, payload };
}

export function addRouterParamsTab(payload) {
  return { type: ADD_ROUTER_PARAMS_TAB, payload };
}

export function removeRouterParamsTabs(payload) {
  return { type: REMOVE_ROUTER_PARAMS_TABS, payload };
}

export function setRouterParamsTabs(payload) {
  return { type: SET_ROUTER_PARAMS_TABS, payload };
}

export function addRouterParamsPageSettings(payload) {
  return { type: ADD_ROUTER_PARAMS_PAGE_SETTINGS, payload };
}

export function expandMainNavigation(payload) {
  return { type: EXPAND_MAIN_NAVIGATION, payload };
}

export function collapseMainNavigation(payload) {
  return { type: COLLAPSE_MAIN_NAVIGATION, payload };
}

export function expandSettingsNavigation(payload) {
  return { type: EXPAND_SETTINGS_NAVIGATION, payload };
}

export function collapseSettingsNavigation(payload) {
  return { type: COLLAPSE_SETTINGS_NAVIGATION, payload };
}

export function expandPrintNavigation(payload) {
  return { type: EXPAND_PRINT_NAVIGATION, payload };
}

export function collapsePrintNavigation(payload) {
  return { type: COLLAPSE_PRINT_NAVIGATION, payload };
}

export function addRouterParamsSettingsSubmenu(payload) {
  return { type: ADD_ROUTER_PARAMS_SETTINGS_SUBMENU, payload };
}

export function removeRouterParamsSettingsSubmenu(payload) {
  return { type: REMOVE_ROUTER_PARAMS_SETTINGS_SUBMENU, payload };
}

export function setRouterParamsSignUpSuccess(payload) {
  return { type: SET_ROUTER_PARAMS_SIGN_UP_SUCCESS, payload };
}

export function removeRouterParamsSignUpSuccess(payload) {
  return { type: REMOVE_ROUTER_PARAMS_SIGN_UP_SUCCESS, payload };
}

export function expandNotificationsDashboard(payload) {
  return { type: EXPAND_NOTIFICATIONS_DASHBOARD, payload };
}

export function collapseNotificationsDashboard(payload) {
  return { type: COLLAPSE_NOTIFICATIONS_DASHBOARD, payload };
}



// WEBPACK FOOTER //
// ./src/redux/modules/routerParams.js